// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-prompt,
.otp-setup {
  color: var(--ion-color-secondary);
  margin: 0 0 0 15px;
}
.otp-prompt h2.ion-align-self-center,
.otp-setup h2.ion-align-self-center {
  text-align: center;
  color: var(--ion-color-secondary);
  opacity: 0.7;
}
.otp-prompt p.ion-align-self-center,
.otp-setup p.ion-align-self-center {
  text-align: center;
  color: var(--ion-color-secondary) white;
  opacity: 0.7;
}
.otp-prompt div.forgot-pass-wrap,
.otp-setup div.forgot-pass-wrap {
  margin-top: 20px;
}
.otp-prompt div.forgot-pass-wrap.back,
.otp-setup div.forgot-pass-wrap.back {
  margin-top: 40px;
  font-size: 18px;
}
.otp-prompt div.forgot-pass-wrap.back span.arrow-icon,
.otp-setup div.forgot-pass-wrap.back span.arrow-icon {
  font-size: 16px;
}

.otp-prompt div.code-input-wrap > ion-list > ion-item {
  --inner-border-width: 0;
  --highlight-background: transparent;
}

code-input {
  --item-spacing: 10px;
  --item-height: 3em;
  --color: var(--mc-color-black);
  --item-border: 2px solid var(--mc-otp-border);
  --item-border-bottom: 2px solid var(--mc-otp-border);
  --item-border-has-value: 2px solid var(--mc-otp-border-strong);
  --item-border-bottom-has-value: 2px solid var(--mc-otp-border-strong);
  --item-border-focused: 2px solid var(--mc-otp-border-focus);
  --item-border-bottom-focused: 2px solid var(--mc-otp-border-focus);
  --item-shadow-focused: none;
  --item-border-radius: 10px;
  margin: 20px 0;
}

ion-input-otp {
  width: 100%;
  --border-color: var(--mc-otp-border) !important;
  --color: var(--mc-color-black);
  --highlight-color-focused: var(--mc-otp-border-focus);
  --border-width: 2px;
  --border-radius: 10px !important;
  --min-width: 2px;
  --font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/otp-prompt/otp-prompt.component.scss"],"names":[],"mappings":"AAAA;;EAEC,iCAAA;EACA,kBAAA;AACD;AACC;;EACC,kBAAA;EACA,iCAAA;EACA,YAAA;AAEF;AACC;;EACC,kBAAA;EACA,uCAAA;EACA,YAAA;AAEF;AACC;;EACC,gBAAA;AAEF;AACC;;EACC,gBAAA;EACA,eAAA;AAEF;AADE;;EACC,eAAA;AAIH;;AACC;EACC,uBAAA;EACA,mCAAA;AAEF;;AAGA;EACC,oBAAA;EACA,kBAAA;EACA,8BAAA;EACA,6CAAA;EACA,oDAAA;EACA,8DAAA;EACA,qEAAA;EACA,2DAAA;EACA,kEAAA;EACA,2BAAA;EACA,0BAAA;EACA,cAAA;AAAD;;AAGA;EACI,WAAA;EACH,+CAAA;EACA,8BAAA;EACA,qDAAA;EACG,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;AAAJ","sourcesContent":[".otp-prompt,\r\n.otp-setup {\r\n\tcolor: var(--ion-color-secondary);\r\n\tmargin: 0 0 0 15px;\r\n\r\n\th2.ion-align-self-center {\r\n\t\ttext-align: center;\r\n\t\tcolor: var(--ion-color-secondary);\r\n\t\topacity: 0.7;\r\n\t}\r\n\r\n\tp.ion-align-self-center {\r\n\t\ttext-align: center;\r\n\t\tcolor: var(--ion-color-secondary)white;\r\n\t\topacity: 0.7;\r\n\t}\r\n\r\n\tdiv.forgot-pass-wrap {\r\n\t\tmargin-top: 20px;\r\n\t}\r\n\r\n\tdiv.forgot-pass-wrap.back {\r\n\t\tmargin-top: 40px;\r\n\t\tfont-size: 18px;\r\n\t\tspan.arrow-icon {\r\n\t\t\tfont-size: 16px;\r\n\t\t}\r\n\t}\r\n}\r\n.otp-prompt {\r\n\tdiv.code-input-wrap > ion-list > ion-item {\r\n\t\t--inner-border-width: 0;\r\n\t\t--highlight-background: transparent;\r\n\t}\r\n}\r\n\r\n\r\ncode-input {\r\n\t--item-spacing: 10px;\r\n\t--item-height: 3em;\r\n\t--color: var(--mc-color-black);\r\n\t--item-border: 2px solid var(--mc-otp-border);\r\n\t--item-border-bottom: 2px solid var(--mc-otp-border);\r\n\t--item-border-has-value: 2px solid var(--mc-otp-border-strong);\r\n\t--item-border-bottom-has-value: 2px solid var(--mc-otp-border-strong);\r\n\t--item-border-focused: 2px solid var(--mc-otp-border-focus);\r\n\t--item-border-bottom-focused: 2px solid var(--mc-otp-border-focus);\r\n\t--item-shadow-focused: none;\r\n\t--item-border-radius: 10px;\r\n\tmargin: 20px 0;\r\n}\r\n\r\nion-input-otp {\r\n    width: 100%;\r\n\t--border-color: var(--mc-otp-border) !important;\r\n\t--color: var(--mc-color-black);\r\n\t--highlight-color-focused: var(--mc-otp-border-focus);\r\n    --border-width: 2px;\r\n    --border-radius: 10px !important;\r\n    --min-width: 2px;\r\n    --font-size: 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
